class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

/* [Modified by Codex at 2026-10-14] 在现有菜单组件中提供可关闭的桌面悬停展开并支持分区重载 */
class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = this.closest('.header-wrapper');
  }

  connectedCallback() {
    this.header = this.closest('.header-wrapper');
    this.pointerInside = false;
    this.summary = this.mainDetailsToggle.querySelector('summary');
    this.summary.setAttribute('aria-expanded', String(this.mainDetailsToggle.open));
    this.boundKeyUp = this.onKeyUp.bind(this);
    this.addEventListener('keyup', this.boundKeyUp, true);
    this.hoverEnabled = this.header?.dataset.menuHoverOpen === 'true';
    if (!this.hoverEnabled) return;

    this.hoverMedia = window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)');
    this.boundPointerEnter = this.onPointerEnter.bind(this);
    this.boundPointerLeave = this.onPointerLeave.bind(this);
    this.boundMediaChange = this.onMediaChange.bind(this);
    this.addEventListener('pointerenter', this.boundPointerEnter);
    this.addEventListener('pointerleave', this.boundPointerLeave);
    this.hoverMedia.addEventListener('change', this.boundMediaChange);
  }

  disconnectedCallback() {
    clearTimeout(this.closeTimer);
    clearTimeout(this.focusOutTimer);
    this.removeEventListener('keyup', this.boundKeyUp, true);
    if (!this.hoverMedia) return;
    this.removeEventListener('pointerenter', this.boundPointerEnter);
    this.removeEventListener('pointerleave', this.boundPointerLeave);
    this.hoverMedia.removeEventListener('change', this.boundMediaChange);
  }

  onPointerEnter(event) {
    if (event.pointerType !== 'mouse' || !this.hoverMedia.matches) return;
    clearTimeout(this.closeTimer);
    this.pointerInside = true;
    this.header.querySelectorAll('header-menu').forEach((menu) => {
      if (menu !== this) menu.close();
    });
    this.mainDetailsToggle.open = true;
    this.onToggle();
  }

  onPointerLeave(event) {
    if (event.pointerType !== 'mouse') return;
    this.pointerInside = false;
    clearTimeout(this.closeTimer);
    this.closeTimer = setTimeout(() => {
      if (!this.pointerInside && !this.contains(document.activeElement)) this.close();
    }, 150);
  }

  onMediaChange() {
    if (this.hoverMedia.matches) return;
    this.pointerInside = false;
    this.close();
  }

  onFocusOut() {
    clearTimeout(this.focusOutTimer);
    this.focusOutTimer = setTimeout(() => {
      if (!this.contains(document.activeElement) && !(this.hoverEnabled && this.pointerInside)) this.close();
    });
  }

  onKeyUp(event) {
    if (event.key !== 'Escape') return;
    const details = event.target.closest('details[open]');
    if (!details || !this.contains(details)) return;
    event.preventDefault();
    event.stopPropagation();
    details.open = false;
    const summary = details.querySelector('summary');
    summary.setAttribute('aria-expanded', 'false');
    summary.focus();
    this.onToggle();
  }

  close() {
    clearTimeout(this.closeTimer);
    super.close();
    this.onToggle();
  }

  onToggle() {
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', String(this.mainDetailsToggle.open));
    if (!this.header) return;
    this.header.preventHide = Boolean(this.header.querySelector('header-menu > details[open]'));

    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}
/* [End] */

customElements.define('header-menu', HeaderMenu);
